import { IsoCardModel, IsoCardModelProps as IsoCardModelProps } from '@/src/components/cards/banner-images/iso';
import { IsoCardsCaraousl } from './card-carousel';

export interface IsoModelSectionProps {
   cards: IsoCardModelProps[];
}

export function IsoModelSection({ cards }: IsoModelSectionProps) {
   return (
      <section className="overflow-hidden">
         <IsoCardsCaraousl cards={cards} />
      </section>
   );
}